import { IBoltVerifyTwoStepsRequest, IBoltVerifyTwoStepsResponse } from '../../../entity/interface/iSubscription';
import { container } from '../../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import { ISubscriptionRepository } from '../../repositories/interfaces/iSubscriptionRepository';

export interface IBoltUserVerificationTwoStepsUseCase {
    execute(
        payload: IBoltVerifyTwoStepsRequest,
        apiToken: { [key: string]: string }
    ): Promise<IBoltVerifyTwoStepsResponse>;
}

export class BoltUserVerificationTwoStepsUseCase implements IBoltUserVerificationTwoStepsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get subscriptionRepository(): ISubscriptionRepository {
        return container.resolve<ISubscriptionRepository>(DI.REPOSITORIES.ISubscriptionRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        payload: IBoltVerifyTwoStepsRequest,
        apiToken: { [key: string]: string }
    ): Promise<IBoltVerifyTwoStepsResponse> {
        return await this.subscriptionRepository.boltUserVerificationTwoSteps(payload, apiToken);
    }
}
